import React, { useState } from "react";
import Image1 from "./bg_section5/webp/3Installation de mur tendu imprimé nature et plafond lumineux tendu dans une salle moderne – Unik System Maroc.webp";
import Image2 from "./bg_section5/webp/1_A.webp";
import Image3 from "./bg_section5/webp/1_L.webp";
import Image4 from "./bg_section5/webp/1_PS.webp";
import Image5 from "./bg_section5/webp/US_SHADE.webp";
import Image6 from "./bg_section5/webp/7Plafond tendu lumineux décoratif dans salle pour enfants – solution d’éclairage diffus Unik System.webp";
import Image7 from "./bg_section5/webp/2_A.webp";
import Image8 from "./bg_section5/webp/34Plafond architectural moderne.webp";
import Image9 from "./bg_section5/webp/36Grand espace professionnel avec vitrages équipés de solutions de protection solaire et éclairage naturel maîtrisé.webp";
import Image10 from "./bg_section5/webp/2_AT.webp";
import Image11 from "./bg_section5/3_P.webp";
import Image12 from "./bg_section5/webp/3_A.webp";
import Image13 from "./bg_section5/webp/3_L.webp";
import Image14 from "./bg_section5/webp/3_PS.webp";
import Image15 from "./bg_section5/webp/3_AT.webp";
import Image16 from "./bg_section5/4_P.webp";
import Image17 from "./bg_section5/webp/4_A.webp";
import Image18 from "./bg_section5/webp/4_L.webp";
import Image19 from "./bg_section5/webp/4_PS.webp";
import Image20 from "./bg_section5/webp/4_AT.webp";
import Image21 from "./bg_section5/webp/5_P.webp";
import Image22 from "./bg_section5/Solution Acoustique.jpeg";
import Image23 from "./bg_section5/webp/1Plafond tendu circulaire avec éclairage LED intégré, design architectural moderne pour espace professionnel – UNIK SYSTEM.webp";
import Image24 from "./bg_section5/webp/18Store banne motorisé pour terrasse de villa moderne avec piscine – solution protection solaire UNIK SYSTEM.webp";
import Image25 from "./bg_section5/webp/21Structure textile pour piscine avec couverture transparente et ossature métallique – protection climatique et design architectural.webp";
import Image26 from "./bg_section5/webp/1.webp";
import Image27 from "./bg_section5/webp/2.webp";
import Image28 from "./bg_section5/webp/3.webp";
import IconClose from "./icon/1.png";
import IconPrev from "./icon/2.png";
import IconNext from "./icon/3.png";

const Portfolio = () => {
  const [selectedFilter, setSelectedFilter] = useState("*");
  


  const filters = [
    { label: "All", value: "*" },
    { label: "Solution Plafonds et Murs Tendus", value: "Solution Plafonds et Murs Tendus" },
    { label: "Solution Acoustique", value: "Solution Acoustique" },
    { label: "Solution Art Deco", value: "Solution Art Deco" },
    { label: "Solution Lighting", value: "Solution Lighting" },
    { label: "Solution Architecture Textil", value: "Solution Architecture Textil" },
    { label: "Solution Protection solaire", value: "Solution Protection solaire" },
  ];

  const items = [
    { id: 1, category: "Solution Plafonds et Murs Tendus", image: Image1, title: "Solution Plafonds et Murs Tendus"},
    { id: 2, category: "Solution Acoustique", image: Image2, title: "Solution Acoustique - Piscine olympique rabat" },
    { id: 3, category: "Solution Lighting", image: Image3 , title: "soltution lighting - Gare Rabat Agdal" },
    { id: 4, category: "Solution Protection solaire", image: Image4, title: "Solution Protection solaire film solaire Argent 50 - casa tramway" },
    { id: 5, category: "Solution Architecture Textil", image: Image5, title: "Solution Architecture Textil - Canopée école Américaine" },
    { id: 6, category: "Solution Plafonds et Murs Tendus", image: Image6, title: "Solution Plafonds et Murs Tendus - villa particulier" },
    { id: 7, category: "Solution Acoustique", image: Image7, title: "Solution Acoustique - POD Médium" },
    { id: 8, category: "Solution Lighting", image: Image8, title: "Solution Lighting - toile translucide rétroéclairée" },
    { id: 9, category: "Solution Protection solaire", image: Image9, title: "Solution Protection solaire Pergola" },
    { id: 10, category: "Solution Architecture Textil", image: Image10, title: "Solution Architecture Textil - Canopée école Américaine" },
    { id: 11, category: "Solution Plafonds et Murs Tendus", image: Image11, title: "Solution Plafonds et Murs Tendus  Mur toile Imprimée - Ecole" },
    { id: 12, category: "Solution Acoustique", image: Image12, title: "Solution Acoustique - Panneaux feutrine PET" },
    { id: 13, category: "Solution Lighting", image: Image13, title: "Solution Lighting - caisson lumineux en toile translucide" },
    { id: 14, category: "Solution Protection solaire", image: Image14, title: "Solution Protection solaire - Stores Extérieurs en toile micro perforée anti UV" },
    { id: 15, category: "Solution Architecture Textil", image: Image15, title: "Solution Architecture Textil OFPPT Guelmim" },
    { id: 16, category: "Solution Plafonds et Murs Tendus", image: Image16, title: "Solution Mur Tendu - Toile rétro - éclairée impimée" },
    { id: 17, category: "Solution Acoustique", image: Image17, title: "Solution Acoustique - Toile acoustique avec une mouse - Pôle sportif UM6P Lydex" },
    { id: 18, category: "Solution Lighting", image: Image18, title: "Solution Lighting - Bowling" },
    { id: 28, category: "Solution Art Deco", image: Image28, title: "Solution Art Deco - Toile de décoration" },
    { id: 19, category: "Solution Protection solaire", image: Image19, title: "Solution Protection solaire - Film Solaire" },
    { id: 20, category: "Solution Architecture Textil", image: Image20, title: "Solution Architecture Textile  Marjane Laayoune" },
    { id: 21, category: "Solution Plafonds et Murs Tendus", image: Image21, title: "Solution Plafonds Tendu - Circulaire en toile rétroéclairée Gray Hôtel" },
    { id: 22, category: "Solution Acoustique", image: Image22, title: "Solution Acoustique - Revêtement mural Acoustique - salle de conférence UMP6 Rabat" },
    { id: 23, category: "Solution Lighting", image: Image23, title: "Solution Lighting - Toile translucide rétroéclairée" },
    { id: 27, category: "Solution Art Deco", image: Image27, title: "Solution Art Deco - Toile de décoration" },
    { id: 24, category: "Solution Protection solaire", image: Image24, title: "Solution Protection solaire - Façade Bioclimatique" },
    { id: 25, category: "Solution Architecture Textil", image: Image25, title: "Solution Architecture Textile - Club Sportif O'Darb" },
    { id: 26, category: "Solution Art Deco", image: Image26, title: "Solution Art Deco - Toile de décoration" },
    
  ];

  const filteredItems =
    selectedFilter === "*"
      ? items
      : items.filter((item) => item.category === selectedFilter);

  const [lightbox, setLightbox] = useState(null);
  const nextImage = () => {
  setLightbox((prev) => {
    const newIndex = (prev.index + 1) % filteredItems.length;
    return {
      index: newIndex,
      image: filteredItems[newIndex].image,
      title: filteredItems[newIndex].title,
    };
  });
};

const prevImage = () => {
  setLightbox((prev) => {
    const newIndex =
      (prev.index - 1 + filteredItems.length) % filteredItems.length;
    return {
      index: newIndex,
      image: filteredItems[newIndex].image,
      title: filteredItems[newIndex].title,
    };
  });
};
  const openLightbox = (index) => {
  setLightbox({
    index,
    image: filteredItems[index].image,
    title: filteredItems[index].title,
  });
};


  return (
    <div className="portfolio-section">
      {/* Filtres */}
      <ul data-aos="fade-up" className="portfolio-filters">
        {filters.map((f, index) => (
          <li
            key={index}
            className={selectedFilter === f.value ? "active" : ""}
            onClick={() => setSelectedFilter(f.value)}
          >
            {f.label}
          </li>
        ))}
      </ul>

      {/* Galerie */}
      <div className="portfolio-grid">
        {filteredItems.map((item, index) => (
          <div
            data-aos="zoom-in"
            data-aos-duration="3000"
            key={item.id}
            className="portfolio-item"
            onClick={() => openLightbox(index)}
          >
            <img loading="lazy" src={item.image} alt="Images Solution Plafonds et Murs Tendus Solution Acoustique Solution Lighting Solution Architecture Textil Solution Protection solaire" />
            <div className="overlay">
              <i className="fa fa-search"></i>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
  <div className="lightbox" onClick={() => setLightbox(null)}>
    <div className="content" onClick={(e) => e.stopPropagation()}>
      
      
      <button className="close2" onClick={() => setLightbox(null)}>
        <img src={IconClose} alt="close" />
      </button>

      <button className="prev" onClick={prevImage}>
        <img src={IconPrev} alt="prev" />
      </button>

      <img
        src={lightbox.image}
        alt={lightbox.title}
        className="lightbox-img"
      />

      {/* ✅ TITLE */}
      <div className="image-title">
        {lightbox.title}
      </div>

      <button className="next" onClick={nextImage}>
        <img src={IconNext} alt="next" />
      </button>

    </div>
  </div>
)}

    </div>
  );
};

export default Portfolio;
